// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"75fd891e","453":"0e76ae6b","455":"efdf460c","977":"9c514479"}[chunkId] + ".chunk.js";
};